import web3 from '../web3'

export async function signAndSendTransaction(method, privateKey) {
  const options = {
    to: method._parent._address,
    data: method.encodeABI(),
    gas: 1000000
  }

  let signedTransaction = await web3.eth.accounts.signTransaction(
    options,
    privateKey
  )

  return await web3.eth.sendSignedTransaction(signedTransaction.rawTransaction)
}
